import { Trans } from 'react-i18next';
import styles from '../reward-details-card.module.scss';

function Labels({
  label,
  earnStars,
  earnedAmount,
  text,
}: {
  label: () => React.ReactElement;
  earnStars: string;
  earnedAmount: string;
  text: string;
}) {
  const notFullyAchieved = parseInt(earnStars) - parseInt(earnedAmount) > 0;

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap gap-4 gap-md-0">
      <div className="d-flex justify-content-between flex-grow-1 align-items-center">
        <p className="m-0 flex-grow-1 text-label cust-pr-1 cust-mb-2">{text}</p>
        {notFullyAchieved && (
          <p
            className={`${styles.stars} text-label text-label-bold text-primary mb-0 cust-mr-2 d-flex align-items-center justify-content-end`}
          >
            <Trans
              i18nKey={'rewards.label.earnUpToStars'}
              default={'Earn up to {{number}} stars'}
              values={{ number: earnStars }}
              components={{ i: <i className="icon-star_full text-body-small ml-1" /> }}
            />
          </p>
        )}
      </div>
      <div className="flex-grow-1 flex-md-grow-0 d-flex justify-content-center align-items-start">{label()}</div>
    </div>
  );
}

export default Labels;